// Loads recipes from recipes.json and validates against RecipeSchema at
// module load. If a CMS edit produces malformed JSON, this throws at import
// time — the build (or dev server) fails loudly instead of rendering broken UI.

import recipesJson from './recipes.json';
import { Recipe, RecipesSchema } from '../schemas/recipe';

export type { Recipe };
export const RECIPES: Recipe[] = RecipesSchema.parse(recipesJson);
